<template>
  <v-container fluid>
    <v-dialog
        v-model="editDialog"
        max-width="700px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ isEditing ? 'Редактирование данных' : 'Добавление'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.name" label="Наименование"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-file-input
                    v-model="photo"
                    label="Логотип"
                    truncate-length="15"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="save"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
        Марки авто
      </v-card-title>
    </v-card>
    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-row>
              <v-col>
                <v-btn
                    @click="addJob"
                    depressed
                    color="primary"
                >
                  <v-icon
                      left
                      dark
                  >
                    mdi-plus
                  </v-icon>
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
              class="mr-2"
              @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
              class="mr-2"
              @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'AdminSpareBrands',
  data() {
    return {
      editedItem: {
        name: ''
      },
      editDialog: false,
      data: [],
      size: 10,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Наименование', value: 'name' },
        { text: 'Дата создания', value: 'createdAt' },
        { text: 'Дата обновления', value: 'updatedAt' },
        { text: 'Действия', value: 'actions' },
      ],
      isEditing: false,
      photo: ''
    }
  },
  watch: {
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData () {
      try {
        this.data = await this.$store.dispatch('carController/getCarBrandList')
      } catch (e) {
        console.log(e)
      }
    },
    addJob() {
      this.editDialog = true
    },
    close () {
      this.isEditing = false
      this.editDialog = false
      this.editedItem = {
        name: '',
      }
    },
    async save () {
      if (this.isEditing) {
        try {
          await this.$store.dispatch('carController/updateCarBrand', this.editedItem)
          showSnackbar({
            message: "Успешно обновлено!",
            color: "success",
            timeout: 3000,
          })
          this.getData()
        } catch (e) {
          showSnackbar({
            message: "Не удалось обновить",
            color: "error",
            timeout: 3000,
          })
        }
      } else {
        try {
          const formData = new FormData()
          formData.append('name', this.editedItem.name)
          formData.append('logo', this.photo)
          await this.$store.dispatch('carController/createCarBrand', this.editedItem)
          showSnackbar({
            message: "Успешно добавлено!",
            color: "success",
            timeout: 3000,
          })
          this.getData()
        } catch (e) {
          showSnackbar({
            message: "Не удалось добавить",
            color: "error",
            timeout: 3000,
          })
        }
      }
      this.isEditing = false
      this.editDialog = false
      this.editedItem = {
        name: '',
      }
    },
    async deleteItem (item) {
      try {
        if (confirm('Вы точно хотите удалить данные?')) {
          await this.$store.dispatch('carController/deleteCarBrand', item.id)
          this.getData()
          showSnackbar({
            message: "Успешно удалено!",
            color: "success",
            timeout: 3000,
          })
        }
      } catch (e) {
        showSnackbar({
          message: "Не удалось удалить",
          color: "error",
          timeout: 3000,
        })
      }
    },
    editItem (item) {
      this.isEditing = true
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },

  }
}
</script>
<style scoped>

</style>